// Simple React Native specific changes

export default {
  // font scaling override - RN default is on
  allowTextFontScaling: true,
  baseURL: process.env.REACT_APP_BASE_URL,
  apiURL: process.env.REACT_APP_API_URL
}
